import React from 'react'
import { View, Text, StyleSheet, Image, TouchableOpacity, ScrollView } from 'react-native'
import { useTheme } from '@/contexts/ThemeContext'
import { posts } from '@/content/blog/posts'
import { useRouter } from 'expo-router'

export default function BlogIndexFallback() {
  const { colors } = useTheme()
  const router = useRouter()

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    header: {
      paddingHorizontal: 24,
      paddingVertical: 32,
    },
    title: {
      fontSize: 28,
      fontFamily: 'Inter-Bold',
      color: colors.text,
      marginBottom: 8,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 16,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
      textAlign: 'center',
    },
    list: {
      paddingHorizontal: 24,
      paddingVertical: 24,
      gap: 20,
    },
    card: {
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: 12,
      overflow: 'hidden',
      backgroundColor: colors.surface,
    },
    image: {
      width: '100%',
      height: 200,
    },
    cardContent: {
      paddingHorizontal: 16,
      paddingVertical: 16,
      gap: 8,
    },
    cardTitle: {
      fontSize: 18,
      fontFamily: 'Inter-SemiBold',
      color: colors.text,
    },
    cardExcerpt: {
      fontSize: 14,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
    },
    cardMeta: {
      fontSize: 12,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
    },
    cardButton: {
      marginTop: 12,
      paddingVertical: 12,
      borderRadius: 10,
      alignItems: 'center',
      backgroundColor: colors.primary,
    },
    cardButtonText: {
      color: '#FFFFFF',
      fontSize: 14,
      fontFamily: 'Inter-SemiBold',
    },
  })

  return (
    <ScrollView style={styles.container} contentContainerStyle={{ paddingBottom: 40 }}>
      <View style={styles.header}>
        <Text style={styles.title}>Blog</Text>
        <Text style={styles.subtitle}>Conteúdos disponíveis também no app com formatação simplificada</Text>
      </View>

      <View style={styles.list}>
        {posts.map((post) => (
          <View key={post.slug} style={styles.card}>
            {post.imageUrl ? (
              <Image source={{ uri: post.imageUrl }} style={styles.image} resizeMode="cover" />
            ) : null}
            <View style={styles.cardContent}>
              <Text style={styles.cardTitle}>{post.title}</Text>
              <Text style={styles.cardExcerpt}>{post.excerpt}</Text>
              <Text style={styles.cardMeta}>{new Date(post.date).toLocaleDateString('pt-BR')}</Text>
              <TouchableOpacity
                onPress={() => router.push(`/blog/${post.slug}`)}
                style={styles.cardButton}
                activeOpacity={0.8}
              >
                <Text style={styles.cardButtonText}>Ler artigo</Text>
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </View>
    </ScrollView>
  )
}
